// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"ea06575c","562":"3c39b6c8","774":"2903aa5a","787":"fc28bc62"}[chunkId] + ".chunk.js";
};